import { Injectable } from '@angular/core';
import {
    Dashboard,
    SearchResult,
    Summary,
    AnalysisData,
    PreviousAnalysis, PreviousAnalysisData, AnalysisKey, AuthLog, RDSAnalysisData, RDSAuditData,

} from '../model/analysis-details.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { AuthNewService } from './auth-new.service';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';


@Injectable({
    providedIn: 'root'
})
export class DBService {
    AnalysisURL: string = environment.serverUrl + '/analysis-data';
    AuthURL: string = environment.serverUrl + '/auth-data';
    RDSAnalysisURL: string = environment.serverUrl + '/analysis_history';
    ValidationURL: string = environment.serverUrl + '/initiate-analysis';
    regressionUrl: string = environment.serverUrl + '/regression';
    AnalysisStatusURL: string = environment.serverUrl + '/analysis-status';

    // RevokeTokenURL:string=environment.serverUrl + '/revoke_token'

    public searchResults: PreviousAnalysis[] = [];
    public recordedLogs: AuthLog[] = [];
    userAttributes?: string;
    singleSearch = new Subject<SearchResult>();
    authLogs = new Subject<AuthLog[]>();
    userSearch = new Subject<PreviousAnalysis[]>();
    rdsAnalysisData = new Subject<RDSAnalysisData[]>();
    rdsAuditData = new Subject<RDSAuditData[]>();
    summary = new Subject<Summary>();

    constructor(private http: HttpClient,
        private storageService: StorageService) {

        this.userSearch.subscribe(
            (data: PreviousAnalysis[]) => {
                this.searchResults = data;
            }
        );
    }


    getUserAnalysis(userId: string) {
        let params = new HttpParams();
        params = params.append('userId', userId);
        params = params.append('analysisId', '');

        this.http.get(this.AnalysisURL, { params: params }).pipe(map(res => <PreviousAnalysisData>res)).subscribe(
            (data) => {
                this.userSearch.next(data.data);
            },
            (error) => {
                console.log('Error in calling data from backend', error);
            }
        );

    }

    getAnalysis(access: string, startdate = 'none', enddate = 'none', auditFlag: boolean, dataCompile: boolean) {
        let params = new HttpParams();
        params = params.append('userId', this.storageService.get('userId') ?? '');
        params = params.append('organization', this.storageService.get('organization') ?? '');
        params = params.append('group', this.storageService.get('group') ?? '');
        params = params.append('access', access);
        params = params.append('startdate', startdate);
        params = params.append('enddate', enddate);
        params = params.append('auditFlag', auditFlag);
        params = params.append('dataCompile', dataCompile)


        if (access === 'GA' || access === 'SU' || access === 'QA' || access === 'PI') {
            this.http.get(this.RDSAnalysisURL, { params: params }).pipe(map(res => <RDSAnalysisData[]>res)).subscribe(
                (data) => {
                    JSON.stringify(data);
                    this.rdsAnalysisData.next(data);
                },
                (error) => {

                }
            );
        }
        else {
            console.log('Unauthorized User');
        }

    }

    getAnalysisStatus(userId: string, analysisId: string, organization: string, group: string) {
        let params = new HttpParams();
        params = params.append('userId', userId);
        params = params.append('analysisId', analysisId);
        params = params.append('organization', organization);
        params = params.append('group', group);
        return this.http.get<AnalysisData>(this.AnalysisStatusURL, { params: params });
    }


    getAuditAnalysis(access: string, startdate = 'none', enddate = 'none', auditFlag: boolean) {
        let params = new HttpParams();
        params = params.append('userId', this.storageService.get('userId') ?? '');
        params = params.append('organization', this.storageService.get('organization') ?? '');
        params = params.append('group', this.storageService.get('group') ?? '');
        params = params.append('access', access);
        params = params.append('startdate', startdate);
        params = params.append('enddate', enddate);
        params = params.append('auditFlag', auditFlag);


        if (access === 'GA' || access === 'SU' || access === 'QA' || access === 'PI') {
            this.http.get(this.RDSAnalysisURL, { params: params }).pipe(map(res => <RDSAuditData[]>res)).subscribe(
                (data) => {
                    JSON.stringify(data);
                    this.rdsAuditData.next(data);
                },
                (error) => {
                    console.log(error)
                }
            );
        }
        else {
            console.log('Unauthorized User');
        }

    }

    getAnalysisDetails(userName: string, analysisId: string) {
        let params = new HttpParams();
        params = params.append('userId', userName);
        params = params.append('analysisId', analysisId);
        // params = params.append('type', null);
        // params = params.append('path', null);

        this.http.get(this.AnalysisURL, { params: params }).pipe(map(res => <AnalysisData>res)).subscribe(
            (data) => {
                this.singleSearch.next(data.data);
            },
            (error) => {
                console.log(error);
            }
        );

    }


    public getDashBoardData(): Dashboard[] {
        const dashBoardObj: Dashboard[] = [];
        for (const obj of this.searchResults) {
            const analysisDetails: AnalysisKey = JSON.parse('obj.key');
            const dbobj: Dashboard = {
                'userId': obj.userId,
                'analysisDate': obj.analysisId ? new Date(parseInt(obj.analysisId, 10)) : undefined,
                'analyteNames': this.getAnalyteNames(analysisDetails),
                'analysisType': analysisDetails.analysisType,
                'analysisSubtype': analysisDetails.analysisSubtype,
                'projectCode': 'analysisDetails.projectCode',
                // 'projectCodeMV': 'analysisDetails.projectCodeMV'
            };
            dashBoardObj.push(dbobj);
        }
        return dashBoardObj;
    }

    public getSAProjectCodes(): any[] {
        const mySet = new Set();
        const dashboardObjs = this.getDashBoardData();
        for (const obj of dashboardObjs) {
            if (obj.projectCode) {
                mySet.add(obj.projectCode);
            }
        }
        return Array.from(mySet.values());
    }

    public getMVProjectCodes(): any[] {
        const mySet = new Set();
        const dashboardObjs = this.getDashBoardData();
        for (const obj of dashboardObjs) {
            // if (obj.projectCodeMV) {
            //     mySet.add(obj.projectCodeMV)
            // }
        }
        return Array.from(mySet.values());
    }

    public getAnalyteNames(analysisDetails: any) {
        const analytes: string[] = [];
        for (const analyte of analysisDetails?.analytes) {
            analytes.push(analyte.analyteName);
        }
        return analytes;
    }

    // Authentication
    recordAuthEvent(event: string) {
        const data = { 'event': event };
        return this.http.post(this.AuthURL, data);
    }

    getAuthData(loginId: string, userId: string, LogstartDate = 'none', LogendDate = 'none') {
        let params = new HttpParams();
        params = params.append('loginId', loginId);
        params = params.append('userId', userId);
        params = params.append('start_date', LogstartDate);
        params = params.append('end_Date', LogendDate);
        const UserAttributes = this.storageService.get('access');
        if (UserAttributes === 'SU' || UserAttributes === 'GA') {

            this.http.get(this.AuthURL, { params: params }).pipe(map(res => <AuthLog[]>res)).subscribe(
                (logs) => {
                    this.authLogs.next(logs);
                },
                (error) => {
                    console.log('Error in calling data from backend', error);
                }
            );
        }
        else {
            console.log('Unauthorized User');
        }
    }

}
